import React from "react";
import { Row, Col, Form } from "antd";
import PropTypes from "prop-types";
import InputComponent from "../InputComponent/InputComponent";
import {
  GrantAgreementSectionLastHeading,
  WrapLabel,
  ErrorMsgWrap,
  ContentWrapper,
  GrantAllocationInputMargin
} from "../../styles";

function AmountRecommendGrantAllocation(props) {
  // Handle Blur condition should check for below $25000 and show a popup.

  const {
    amountChangeHandler,
    grantAmountPopUpHandler,
    amount,
    amountValidatorContent= 'Please enter grant amount'
  } = props;

  return (
    <div>
      <Row>
        <Col>
          <GrantAgreementSectionLastHeading style={{ marginBottom: '30px'}}>
            Recommended Grant Allocations
          </GrantAgreementSectionLastHeading>
        </Col>
      </Row>
      <Row>
        <Col lg={{ span: 7 }} md={{ span: 7 }}>
          <Form hideRequiredMark>
            <WrapLabel>
              <GrantAllocationInputMargin marginBottom='30px'>
                <InputComponent
                  id="txtGrantAgreementAmount"
                  focus={true}
                  labelValue='Total grant agreement amount*'
                  name='amount'
                  ariaLabel="amount"
                  maxLength={100}
                  role="textbox"
                  value={amount}
                  onBlur={grantAmountPopUpHandler}
                  onChange={amountChangeHandler}
                  marginBottom='0px'
                />
              </GrantAllocationInputMargin>
            </WrapLabel>
          </Form>
        </Col>
      </Row>
      <Row>
      <Col>
        {props.individualValidator &&
                <ErrorMsgWrap>
                  {amountValidatorContent}
                </ErrorMsgWrap>}
        </Col>
      </Row>
      <div className="mt-30">
        <ContentWrapper>
          *This entire amount will be unavailable once the grant agreement is
          approved by Vanguard Charitable and throughout the entire term of the
          agreement.
        </ContentWrapper>
      </div>
    </div>
  );
}

AmountRecommendGrantAllocation.propTypes = {
  amount: PropTypes.string,
  amountChangeHandler: PropTypes.func,
  amountValidatorContent: PropTypes.string,
  grantAmountPopUpHandler: PropTypes.func,
  individualValidator: PropTypes.bool
}

export default AmountRecommendGrantAllocation;
